import React, { useRef } from 'react';
import { FormDialog } from 'components/dialogs/formDialog';
import { CheckboxWrapper } from 'components/formInputs/wrappers/checkboxWrapper';
import { Config } from 'configs';

export const AvailableLanguagesSelectForm = ({ isOpen, closeModal, selectedLanguages, onChange }) => {
  const cancelButtonRef = useRef(null);

  return (
    <FormDialog
      isOpen={isOpen}
      cancelButtonRef={cancelButtonRef}
      onClose={closeModal}
      title="Adjust available languages"
      buttons={[
        { text: 'Close', onClick: closeModal, color: 'gray' },
      ]}
      small
    >
      <div className="flex flex-row flex-wrap">
        {Config.AVAILABLE_LANGUAGES.map((lang) => {
          return (
            <div key={lang} className="w-[33%] mb-3">
              <CheckboxWrapper
                name={lang}
                title={lang}
                responsiveClassName="col-span-6"
                checked={selectedLanguages && selectedLanguages.includes(lang)}
                onChange={(e) => {
                  onChange(lang, e.target.checked);
                }}
                disabled={lang === 'en'}
              />
            </div>
          );
        })}
      </div>
    </FormDialog>
  );
};
